<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم والمعايرة (تختفي عند الطباعة) -->
    <div class="card shadow-sm mb-4 no-print border-top-primary">
      <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
        <h5 class="m-0 text-primary fw-bold"><i class="fas fa-print ms-2"></i> طباعة أرقام الجلوس (حشو استمارات)</h5>
        <button @click="printPage" class="btn btn-dark px-4"><i class="fas fa-print"></i> طباعة</button>
      </div>
      
      <div class="card-body bg-light">
        <div class="row g-3">
            <!-- الفلاتر -->
            <div class="col-md-3">
                <label class="small fw-bold">المدرسة</label>
                <select v-model="form.school_id" class="form-select" @change="fetchStudents">
                    <option value="">اختر المدرسة</option>
                    <option v-for="s in schools" :key="s.id" :value="s.id">{{ s.school_name }}</option>
                </select>
            </div>
            
            <!-- أدوات ضبط المسافات (Calibration) -->
            <div class="col-md-9 border-start border-2 ps-3">
                <label class="small fw-bold text-danger mb-2 d-block">أدوات ضبط الأماكن (حرك الأرقام لتناسب الورقة المطبوعة)</label>
                <div class="d-flex gap-3">
                    <div class="input-group input-group-sm">
                        <span class="input-group-text">إزاحة يمين (سم)</span>
                        <input type="number" step="0.1" v-model="margins.right" class="form-control">
                    </div>
                    <div class="input-group input-group-sm">
                        <span class="input-group-text">إزاحة علوية (سم)</span>
                        <input type="number" step="0.1" v-model="margins.top" class="form-control">
                    </div>
                    <div class="input-group input-group-sm">
                        <span class="input-group-text">المسافة بين الأرقام (سم)</span>
                        <input type="number" step="0.1" v-model="margins.gap" class="form-control">
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة -->
    <div id="printMe" v-if="students.length > 0">
      
      <!-- حلقة تكرار لكل طالب -->
      <div v-for="(student, index) in students" :key="index" >
        
        <!-- ========================================== -->
        <!-- الورقة الأولى: رقم الجلوس فقط (يمين) -->
        <!-- ========================================== -->
        <div class="print-page page-1" >
            <div class="seat-number-box fa-25" :style="{ 
                top: margins.top + 'cm', 
                right: margins.right + 'cm' 
            }">
                {{ student.Seating_No }}
            </div>
        </div>

        <!-- ========================================== -->
        <!-- الورقة الثانية: التكرار + اللجنة + الختم -->
        <!-- ========================================== -->
        <div class="print-page page-2" >
            
            <!-- أ) الختم (أعلى الصفحة) -->
            <div v-if="getStampType(student)" class="stamp-box">
                <!-- {{ getStampType(student) }} -->
            </div>

            <!-- ب) أرقام الجلوس الثلاثة (ناحية اليمين) -->
            <div class="seats-vertical" style="margin-right:5cm; margin-top:6cm">
                <div class="seat-item fa-25">{{ student.Seating_No }}</div>
                <div class="seat-item fa-25" style="margin-top:10cm">{{ student.Seating_No }}</div>
                <div class="seat-item fa-25" style="margin-top:11cm">{{ student.Seating_No }}</div>
            </div>

            <!-- ج) اسم اللجنة (ناحية اليسار) -->
            <div class="committee-box" style="border: 2px solid;left: -7cm;top: 16cm;height: 2cm;width: 6cm;">
                <span class="fw-bold fs-15">{{ student.committee_name }}</span>
            </div>
            <div class="committee-box" style="left: -7cm;top: 19cm;height: 2cm;width: 6cm;">
                <span class="fw-bold fs-15">محمد كُريم محمود</span>
            </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "SeatingCardsPrint",
  data() {
    return {
      loading: false,
      schools: [],
      students: [],
      form: { school_id: '' },
      
      // إعدادات المعايرة الافتراضية (بالسنتيمتر)
      // يمكنك تغييرها من الشاشة لتناسب الورقة المطبوعة لديك
      margins: {
          top: 6.0,    // بعد الرقم عن أعلى الورقة
          right: 3.0,  // بعد الرقم عن يمين الورقة
          gap: 4.0     // المسافة بين كل رقم جلوس والذي يليه في الصفحة الثانية
      }
    };
  },
  mounted() {
      // جلب قائمة المدارس (مثال)
      this.fetchSchools();
      
      // بيانات وهمية للتجربة
    //   this.students = [
    //       { id: 1, Seating_No: '15200', Arabic_Name: 'أحمد محمد', committee_name: 'مدرسة العريش ع بنين', Damg_Status: 'نعم', Stud_Type_Id: 1 },
    //       { id: 2, Seating_No: '15201', Arabic_Name: 'محمود علي', committee_name: 'مدرسة السلام', Damg_Status: 'لا', Stud_Type_Id: 2 },
    //   ];
  },
  methods: {
     async fetchSchools() {
      // تفعيل اللودينج إذا كنت تستخدمه (اختياري)
      // this.loading = true; 

      try {
        // تأكد من أن الرابط يطابق الراوت الموجود في ملف api.php لديك
        // قد يكون '/admin/schools' أو '/getSchool' حسب تسميتك السابقة
        const res = await api.get('/getschools'); 
        
        this.schools = res.data;
      } catch (e) {
        console.error("فشل جلب قائمة المدارس:", e);
        // alert("تعذر تحميل المدارس");
      } finally {
        // this.loading = false;
      }
    },
    
 

    async fetchStudents() {
        if(!this.form.school_id) return;
        this.loading = true;
        try {
            const res = await api.get(`/admin/students/seating-cards?school_id=${this.form.school_id}`);
            this.students = res.data;
        } catch(e) { console.error(e); }
        finally { this.loading = false; }
    },

    getStampType(student) {
        if (student.Damg_Status === 'نعم' || student.Damg_Status === 'دمج') return 'دمج';
        if (student.Stud_Type_Id == 2) return 'منازل';
        return null; // طالب عادي لا يحتاج ختم
    },

    printPage() {
         const options = {
  name: '_balnk',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
 
    '/css/adminlte.rtl.css',
    '/assets/css/rtl.css',
    '/assets/css/setting_card.css',
    'https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap',
   

  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: false, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}
       this.$htmlToPaper("printMe", options, () => {
    console.log("Printing Done");
  });
    }
  }
};
</script>

<style scoped>
/* خطوط عريضة للأرقام */
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@700;900&display=swap');

#printMe {
    font-family: 'Cairo', sans-serif;
    color: #000;
}

/* التنسيق الأساسي للصفحة */
.print-page {
    position: relative;
    width: 210mm;  /* A4 Width */
    height: 297mm; /* A4 Height */
    background: white;
    /* overflow: hidden; */
    page-break-after: always; /* فاصل إجباري بعد كل صفحة */
}

/* تنسيق رقم الجلوس (كبير وواضح) */
.seat-number-box {
    position: absolute;
    font-size: 24pt;
    font-weight: 900;
    letter-spacing: 2px;
}

/* تنسيق العمود الرأسي في الصفحة الثانية */
.seats-vertical {
    position: absolute;
    text-align: center;
}
.seat-item {
    font-size: 24pt;
    font-weight: 900;
}

/* تنسيق اسم اللجنة (يسار) */
.committee-box {
    position: absolute;
    width: 8cm;
    text-align: center;
    border-bottom: 0; /* لا حدود لأن الورقة مطبوعة */
}

/* تنسيق الختم (Stamp Effect) */
.stamp-box {
    position: absolute;
    top: 2cm;
    left: 50%;
    transform: translateX(-50%) rotate(-15deg); /* مائل قليلاً كالختم */
    border: 3px double #000;
    padding: 5px 20px;
    font-size: 24pt;
    font-weight: 900;
    text-transform: uppercase;
    z-index: 10;
    background: transparent; /* شفاف ليظهر فوق أي شيء */
}

/* --- الطباعة --- */
@media print {
    @page {
        size: A4 portrait;
        margin: 0; /* إلغاء الهوامش الافتراضية للطابعة للتحكم الكامل */
    }
    
    .no-print { display: none !important; }
    
    body { background: white; }
    
    /* التأكد من أن الخلفيات شفافة */
    #printMe {
        background-color: transparent !important;
    }
}
</style>